<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Cadastro de Usuário
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="6">
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-text-field
                v-model="usuario.nome"
                label="Nome"
                clearable
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-row>
            <v-row>
              <v-text-field
                v-model="usuario.email"
                label="Email"
                clearable
                :rules="[rules.required, rules.emailMatch]"
                required
              ></v-text-field>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                  :items="perfis"
                  label="Perfis"
                  item-text="nome"
                  item-value="id"
                  :rules="[rules.required]"
                  v-model="usuario.perfilID"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  :items="tipoUsuario"
                  label="Tipos de Usuario"
                  item-text="nome"
                  item-value="id"
                  :rules="[rules.required]"
                  v-model="usuario.tipoUsuario"
                  @change="alterarTipoUsuario()"
                ></v-select>
              </v-col>
              <v-col v-if="usuario.tipoUsuario === 4">
                <v-select
                  :items="empresas"
                  label="Empresas"
                  :item-text="item => item.nome + ' - '+ item.id"
                  item-value="id"
                  v-model="usuario.empresasID"
                  :menu-props="{ maxHeight: '400' }"
                  :rules="[rules.required]"
                  multiple
                  chips
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  :items="timezones"
                  label="Fuso Horário"
                  item-text="descricao"
                  item-value="id"
                  v-model="usuario.timezoneID"
                  required
                >
                </v-select>
              </v-col>
            </v-row>
            <v-divider v-if="usuario.gruposDocumentoUsuario && grupos"></v-divider>
            <v-row v-if="usuario.gruposDocumentoUsuario && grupos">
              <v-col cols="12" sm="6">
                <div style="text-align:center; font-size: 17px;">Visualização de Documentos</div>
                <v-divider></v-divider>
                <v-treeview
                  v-if="usuario.gruposDocumentoUsuarioVisualizacao && grupos"
                  v-model="usuario.gruposDocumentoUsuarioVisualizacao"
                  :items="grupos"
                  :selection-type="selectionType"
                  selectable
                  return-object
                  open-all-on-load
                ></v-treeview>
              </v-col>
              <v-col cols="12" sm="6">
                <div style="text-align:center; font-size: 17px;">Aprovação de Documentos</div>
                <v-divider></v-divider>
                <v-treeview               
                  v-if="usuario.gruposDocumentoUsuario && grupos"
                  v-model="usuario.gruposDocumentoUsuario"
                  :items="grupos"
                  :selection-type="selectionType"
                  selectable
                  return-object
                  open-all-on-load
                ></v-treeview>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-btn @click="voltar" color="error" large class="mr-2"
              >Voltar</v-btn
            >
            <v-btn @click="salvar" color="primary" large :disabled="saving"
              >Salvar</v-btn
            >
          </v-container>
        </v-form>
      </v-col>
      <v-divider vertical></v-divider>

      <v-col>
        <h4>Departamentos com Acesso</h4>
        <v-divider></v-divider>
        <v-treeview
          v-if="usuario.departamentos && departamentos.length > 0"
          v-model="usuario.departamentos"
          :items="departamentos"
          :selection-type="selectionType"
          selectable
          return-object
          open-all-on-load
        ></v-treeview>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  name: "usuarioCadastro",
  data() {
    return {
      valid: false,
      saving: false,
      selectionType: "independent",
      grupos: [],
      usuario: {
        id: 0,
        nome: "",
        email: "",
        administrador: false,
        tipoUsuario: 3,
        representanteID: null,
        clienteID: null,
        perfilID: null,
        empresasID: null,
        logins: [],
        timezoneID: 1,
        departamentos: [],
      },
      cliente: null,
      tipoUsuario: [],
      empresas: [],
      perfis: [],
      timezones: [],
      departamentos: [],
      rules: {
        required: (v) => !!v || "Obrigatório",
        emailMatch: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "O email preenchido não é valido",
      },
      usuarioLogado: {},
    };
  },
  components: {
    TelaLoading,
  },
  methods: {
    async listarDepartamentos() {
      ApiService.get(
        "departamento/gettreeviewbyclienteid",
        this.cliente.id
      ).then(({ data }) => {
        if (data.success){         
          this.departamentos = data.data;
        } 
        else SweetAlert.sweetAlertError(data.errors);
      });
    },
    listarTipoUsuario() {
      if (this.cliente !== null) {
        this.tipoUsuario = [
          { id: 3, nome: "Usuário" },
          { id: 4, nome: "Empresa" },
        ];

        if (this.usuarioLogado.tipoUsuario === 1) {
          this.tipoUsuario.unshift({ id: 1, nome: "Administradores" });
          this.tipoUsuario.unshift({ id: 2, nome: "Representante" });
        }
      }
    },

    alterarTipoUsuario() {
      if (this.usuario.tipoUsuario != 4) {
        this.usuario.empresasID = null;
      }
    },

    async listarEmpresas() {
      const { data: result } = await ApiService.get(
        "empresa/getbyclienteid/" + this.cliente.id
      );

      if (result.success) this.empresas = result.data.filter((x) => x.dataVigenciaFim == null);
      else SweetAlert.sweetAlertError(result.errors);
    },

    async listarTimezones() {
      const { data: result } = await ApiService.get("timezone");

      if (result.success) this.timezones = result.data;
      else SweetAlert.sweetAlertError(result.errors);
    },
    async listarPerfis() {
      const { data: result } = await ApiService.get(
        `perfil/listar/cliente/${this.cliente.id}`,
        ""
      );
      if (result.success) this.perfis = result.data;
    },
    async salvar() {
      let self = this;
      if (this.usuario.tipoUsuario === 4 && this.usuario.empresasID.length == 0) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "É preciso escolher uma empresa para os usuários de tipo empresa",
            showConfirmButton: false,
            timer: 2500,
          });

          return;
      }

      if (this.$refs.form.validate()) {
        this.saving = true;
        this.usuario.administrador = false;

        if (this.usuario.tipoUsuario === 1) {
          this.usuario.administrador = true;
        }

        if (this.usuario.tipoUsuario === 3) {
          this.usuario.clienteID = this.cliente.id;
        }

        const { data: result } =
          this.usuario.id === 0
            ? await ApiService.post("usuario/incluir", this.usuario)
            : await ApiService.put(
                "usuario/alterar/" + this.usuario.id,
                this.usuario
              );

        this.saving = false;

        if (!result.success) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: result.errors[0] || "Ocorreu um erro",
            showConfirmButton: false,
            timer: 2500,
          });

          return;
        }

        Swal.fire({
          position: "center",
          icon: "success",
          title:
            this.usuario.id === 0
              ? "Usuário Cadastrado com Sucesso!"
              : "Usuário Alterado com Sucesso!",
          showConfirmButton: false,
          timer: 2500,
        }).then(function () {
          self.$router.push({ name: "usuario" });
        });
      }
    },

    async listaGrupos() {
      const { data: result } = await ApiService.get(
        "grupoDocumento/gettreeview/" + this.cliente.id
      );

      if (result.success) {
        this.grupos = result.data;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    async buscarUsuario(id) {
      let { data: result } = await ApiService.get("usuario/getbyid/" + id);
      if (result.success) this.usuario = result.data;
      else SweetAlert.sweetAlertError(result.errors);

      this.$store.commit(SET_LOADING, false);
    },

    voltar() {
      this.$router.push({ name: "usuario" });
    },
  },



  async mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    const { usuario } = JSON.parse(window.localStorage.getItem("usuario"));
    this.usuarioLogado = usuario;
    this.usuario.clienteID = this.cliente.id;
    this.usuario.representanteID = this.cliente.representanteID;
    

    this.listarTipoUsuario();
    await this.listaGrupos();
    await this.listarPerfis();
    await this.listarDepartamentos();
    this.listarEmpresas();
    this.listarTimezones();

    if (this.$route.params.id !== undefined)
      await this.buscarUsuario(this.$route.params.id);
    else this.$store.commit(SET_LOADING, false);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Usuario, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
